
import Testimonial from "@/components/Testimonial";

const EducationTestimonials = () => {
  const testimonials = [
    {
      quote: "The AI training program provided practical skills that we implemented immediately in our practice, saving countless hours on document review.",
      author: "Sarah Johnson",
      position: "Partner, Johnson & Smith Law",
      delay: 0
    },
    {
      quote: "As someone with limited technical background, I was worried about keeping up. The course was perfectly paced and made AI accessible for legal practitioners.",
      author: "Michael Chen",
      position: "Associate, Global Legal Partners",
      delay: 0.2
    },
    {
      quote: "Our entire litigation team now leverages AI tools daily after completing the advanced course. It's been a game-changer for our case preparation.",
      author: "Rebecca Taylor",
      position: "Litigation Director, Taylor Legal",
      delay: 0.4
    },
  ];

  return (
    <section className="py-16 md:py-24 px-6 relative bg-gradient-to-b from-background to-background/90">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">What Our Clients Say</h2>
          <p className="text-lg text-white/70 max-w-3xl mx-auto">
            Hear from legal professionals who have transformed their practice through our education programs.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Testimonial 
              key={index}
              quote={testimonial.quote}
              author={testimonial.author}
              position={testimonial.position}
              delay={testimonial.delay}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default EducationTestimonials;
